<template>
  <v-container class="menubar pa-2" fluid v-if="editor">
    <v-row>
      <v-col sm="2" class="text-left">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="menubar__button"
              small
              @click="editor.chain().focus().undo().run()"
              v-on="on"
              :color="$vuetify.theme.themes.light.toolbarButtonBackground"
              v-bind="attrs"
              ><v-icon>mdi-undo</v-icon></v-btn
            >
          </template>
          <span>{{ $t("mainMenu.undo") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="menubar__button"
              small
              @click="editor.chain().focus().redo().run()"
              :color="$vuetify.theme.themes.light.toolbarButtonBackground"
              v-on="on"
              v-bind="attrs"
              ><v-icon>mdi-redo</v-icon></v-btn
            >
          </template>
          <span>{{ $t("mainMenu.redo") }}</span>
        </v-tooltip>
      </v-col>
      <v-col sm="8">
        <v-tooltip
          bottom
          v-for="menuButton in menuButtons"
          :key="menuButton.name + menuButton.level"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-on="on"
              v-bind="attrs"
              class="menubar__button"
              :color="
                editor.isActive(menuButton.name, { level: menuButton.level })
                  ? 'accentElementBackground'
                  : $vuetify.theme.themes.light.toolbarButtonBackground
              "
              :class="
                editor.isActive(menuButton.name, { level: menuButton.level })
                  ? 'is-active'
                  : ''
              "
              @click="clickHandler(menuButton.command)"
            >
              <v-icon>{{ menuButton.icon }} </v-icon>
            </v-btn>
            <div class="divider" v-if="menuButton.hasDivider"></div>
          </template>
          <span>{{ menuButton.hover }}</span>
        </v-tooltip>
        <div class="divider"></div>
        <v-tooltip
          bottom
          v-for="menuButton in alignmentMenuButtons"
          :key="menuButton"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-on="on"
              v-bind="attrs"
              @click="editor.chain().focus().setTextAlign(menuButton).run()"
              class="menubar__button"
              :class="{
                'is-active': editor.isActive({ textAlign: menuButton }),
              }"
              :color="
                editor.isActive({ textAlign: menuButton })
                  ? 'accentElementBackground'
                  : $vuetify.theme.themes.light.toolbarButtonBackground
              "
            >
              <v-icon>mdi-format-align-{{ menuButton }}</v-icon>
            </v-btn>
          </template>
          <span style="text-transform: capitalize">{{ menuButton }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    editor: Object,
  },
  data() {
    return {
      menuButtons: [
        {
          name: "bold",
          command: "toggleBold().run()",
          icon: "mdi-format-bold",
          hover: this.$t("mainMenu.bold"),
        },
        {
          name: "italic",
          command: "toggleItalic().run()",
          icon: "mdi-format-italic",
          hover: this.$t("mainMenu.italic"),
        },
        {
          name: "strike",
          command: "toggleStrike().run()",
          icon: "mdi-format-strikethrough",
          hover: this.$t("mainMenu.strikethrough"),
        },
        {
          name: "heading",
          command: "toggleHeading({ level: 1 }).run()",
          icon: "mdi-format-header-1",
          level: 1,
          hover: this.$t("mainMenu.heading1"),
          hasDivider: true,
        },
        {
          name: "heading",
          command: "toggleHeading({ level: 2 }).run()",
          icon: "mdi-format-header-2",
          level: 2,
          hover: this.$t("mainMenu.heading2"),
        },
        {
          name: "heading",
          command: "toggleHeading({ level: 3 }).run()",
          icon: "mdi-format-header-3",
          level: 3,
          hover: this.$t("mainMenu.heading3"),
        },
        {
          name: "bulletList",
          command: "toggleBulletList().run()",
          icon: "mdi-format-list-bulleted",
          hover: this.$t("mainMenu.bulletedList"),
        },
        {
          name: "orderedList",
          command: "toggleOrderedList().run()",
          icon: "mdi-format-list-numbered",
          hover: this.$t("mainMenu.numberedList"),
        },
        {
          name: "info",
          command: "setInfo().run()",
          icon: "mdi-information",
          hover: this.$t("mainMenu.information"),
        },
      ],
      alignmentMenuButtons: ["left", "center", "right", "justify"],
    };
  },
  methods: {
    clickHandler(command) {
      eval("this.editor.chain().focus()." + command);
    },
  },
};
</script>
<style lang="scss" scoped>
.menubar {
  background-color: var(--v-accentElement-base);
}
.menubar button.menubar__button {
  color: white;
  padding: 0 4px;
  border-radius: 6px;
  min-width: initial;
  margin: 0 4px;
  box-shadow: none;
}
.menubar button.menubar__button.is-active {
  color: var(--v-primaryAction-base);
}
.divider {
  display: inline;
  flex: 0 0 auto;
  height: 15px;
  border: 1px solid var(--v-secondaryBackground-base);
  margin: 0 5px;
}
</style>